
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { a as css } from './chakra-ui-styled-system.esm-a8a2e91f.js';

/**
 * Build a CSS factory function, to create CSS object by given a theme
 * @param {Object} styleProps Styles object
 * @returns {Function} (theme) => CSSStyleObject
 */

var buildCssFn = function buildCssFn(styleProps) {
  return css(styleProps);
};

export default buildCssFn;
